module.exports = __webpack_public_path__ + "img/42_35_440_009.89512793.jpg";